(function() {
	'use strict';

	angular.module('pharmaPortalApp').constant('paginationConstants', {
		'itemsPerPage' : 20
	});
})();
